import { Dispatch, FC, SetStateAction } from 'react';

import { Lightbox } from '@components/Lightbox';
import { Slide } from 'yet-another-react-lightbox';

type Props = {
  isOpen: boolean;
  setLightbox: Dispatch<SetStateAction<boolean>>;
  slides: Slide[];
  initialIndex: number;
};

const ImageLightbox: FC<Props> = ({ slides, isOpen, setLightbox, initialIndex }) => {
  return (
    <Lightbox disableSlideshow open={isOpen} slides={slides} close={() => setLightbox(false)} index={initialIndex} />
  );
};

export default ImageLightbox;
